import React from 'react';
import PropTypes from 'prop-types';
import Category from './Category';

const CategoryPage = ({ category, categorySlug, abTests }) => (
    <div className="category-page">
        <Category category={category} categorySlug={categorySlug} abTests={abTests}/>
    </div>
);

CategoryPage.propTypes = {
    category: PropTypes.object
};

export default CategoryPage;
